import type { VAxios } from '../../define/axios/Axios';
import { TokenResult } from '../../entities/uc/token.entities';

export const createApi = (defHttp: VAxios) => ({
  // 刷新token
  refreshToken(params: { refreshToken: string }) {
    defHttp.setHeader({
      Authorization: '',
    });
    return defHttp.post({
      url: `/uc/login/refresh`,
      params,
    });
  },

  // code换token
  codeToToken: (params: { authorizationCode: string; clientId: string }): Promise<TokenResult> => {
    return defHttp.post<TokenResult>({ url: `/uc/login/token`, params });
  },
});
